import { render } from "./LeadsUploader.vue?vue&type=template&id=b705f6be&scoped=true"
import script from "./LeadsUploader.vue?vue&type=script&lang=js"
export * from "./LeadsUploader.vue?vue&type=script&lang=js"

import "./LeadsUploader.vue?vue&type=style&index=0&id=b705f6be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javier.padilla\\git-repositories\\proyectos.ges.com\\com.ges.proyectos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b705f6be"]])

export default __exports__